<div class="recipt-header">
  <div class="row" style="border-bottom: 1px solid #eee;">
    <div class="col-md-1">
      <img src="/assets/icons/reciept.svg" style="max-width:50px;" />
    </div>
    <div class="col-md-11 ">
      <h4>{{ 'pages.createReceiptPage.oneReceipt.table.receiptDetails' | translate }}</h4>
    </div>
  </div>
  <h5 *ngIf="shippments?.outbound?.length >0"><b>{{ 'common.outbound' | translate }}</b></h5>
  <div *ngFor="let code of getAllCurrency()">
    <table *ngIf="localShipmentsByCurrencyOB[code] && localShipmentsByCurrencyOB[code].length > 0" class="table table-bordered table-striped receipt-table">
      <thead>
        <tr>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.hawb' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.consignee' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.uppperCaseORG' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.upperCaseDST' | translate }}</b></th>
          <th><b>{{ 'common.type' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.upperCaseQTY' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cwgt' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cstms' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cod' | translate }}</b></th>
          <th><b>{{ 'common.discount' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.rtdPrice' | translate }}</b></th>
          <th><b>{{ 'common.total' | translate }}</b></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of localShipmentsByCurrencyOB[code];">
          <td>
            <span class="armx-icon armx-trash delete-btn" (click)="removeShipment('outbound', item.index, code)"></span> 
            <div title="{{ 'common.duplicate' | translate }}" class="duplicate-btn" (click)="onDuplicateShipment(item.data, code)">
              <img src="/assets/icons/duplicate.svg"/>
            </div>
            {{item.data.Shipment.Number}}
          </td>
          <td>
            {{item.data.Shipment.ConsigneeName}}
          </td>
          <td>{{item.data.Shipment.OriginAddress.Entity}}</td>
          <td>{{item.data.Shipment.DestinationAddress.Entity}}</td>
          <td>{{item.data.Shipment.ProductType}}</td>
          <td>{{item.data.Shipment.Quantity}}</td>
          <td>{{fixDecimals(item.data.Shipment.ChargeableWeight.Value)}}</td>
          <td>{{item.data.Shipment.Customs.Value}}
            <span *ngIf="item.data?.Shipment?.Customs?.Value">{{' '+ item.data?.Shipment?.Customs?.Code }}</span>
          </td>
          <td>{{item.data?.Shipment?.CashOnDelivery?.Value}}
          <span *ngIf="item.data?.Shipment?.CashOnDelivery?.Value">{{ ' '+item.data?.Shipment?.CashOnDelivery?.Code }}</span>
          </td>
          <td class="discount">
            <discount-calculator *ngIf="item.data?.Shipment.RatedPrice.Value != 0 && allowDiscountOutbound"
                                 [accountCurrencyCode]="code"
                                 receiptType="outbound"
                                 [discountAmount]="item.data?.DiscountAmount"
                                 [discountComments]="item.data?.DiscountComments"
                                 [cmpDiscountValue]="item.data?.DiscountValue"
                                 [cmpDiscountValueBy]="item.data?.DiscountValueBy"
                                 [currentShipment]="item.data?.Shipment"
                                 [price]="item.data?.Shipment.RatedPrice.Value"
                                 (appliedDiscount)="onDiscountApplied($event, item.index,'outbound')"></discount-calculator>
          </td>
          <td>{{fixDecimals(item.data?.Shipment.RatedPrice.Value) + ' ' + code}}</td>
          <td>{{fixDecimals(item.data?.Amount)+ ' ' + code}}</td>
        </tr>
        <tr class="no-border">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td><b></b></td>
          <td><b></b></td>
          <td><b></b></td>
          <td><b></b></td>
          <td><h3>{{ 'common.total' | translate }}</h3></td>
          <td><h3>{{ fixDecimals(getTotalBasedOnCode(code, 'outbound')) + ' ' + code }}</h3></td>
        </tr>
      </tbody>
    </table>
  </div>
  <h5 *ngIf="shippments?.inbound?.length >0"><b>{{ 'common.inbound' | translate }}</b></h5>
  <div *ngFor="let code of getAllCurrency()">
    <table *ngIf="localShipmentsByCurrencyIB[code] && localShipmentsByCurrencyIB[code].length > 0" class="table table-bordered table-striped receipt-table">
      <thead>
        <tr>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.hawb' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.consignee' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.org' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.dst' | translate }}</b></th>
          <th><b>{{ 'common.type' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.qty' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cwgt' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cstms' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cod' | translate }}</b></th>
          <th><b>{{ 'common.discount' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.rtdPrice' | translate }}</b></th>
          <th><b>{{ 'common.total' | translate }}</b></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of localShipmentsByCurrencyIB[code];">
          <td>
            <span class="armx-icon armx-trash delete-btn" (click)="removeShipment('inbound', item.index, code)"></span> {{item.data.Shipment.Number}}
          </td>
          <td>
            {{item.data.Shipment.ConsigneeName}}
          </td>
          <td>{{item.data.Shipment.OriginAddress.Entity}}</td>
          <td>{{item.data.Shipment.DestinationAddress.Entity}}</td>
          <td>{{item.data.Shipment.ProductType}}</td>
          <td>{{item.data.Shipment.Quantity}}</td>
          <td>{{fixDecimals(item.data.Shipment.ChargeableWeight.Value)}}</td>
          <td>{{item.data.Shipment.Customs.Value}}
            <span *ngIf="item.data?.Shipment?.Customs?.Value">{{' '+ item.data?.Shipment?.Customs?.Code }}</span>
          </td>
          <td>{{fixDecimals(item.data?.Shipment?.CashOnDelivery?.Value)}}
            <span *ngIf="item.data?.Shipment?.CashOnDelivery?.Value">{{ ' '+item.data?.Shipment?.CashOnDelivery?.Code }}</span>
          </td>
          <td class="discount">
            <discount-calculator *ngIf="item.data?.Shipment.RatedPrice.Value != 0 && allowDiscountInbound"
                                 [discountAmount]="item.data?.DiscountAmount"
                                 [accountCurrencyCode]="code"
                                 receiptType="inbound"
                                 [discountComments]="item.data?.DiscountComments"
                                 [cmpDiscountValue]="item.data?.DiscountValue"
                                 [cmpDiscountValueBy]="item.data?.DiscountValueBy"
                                 [currentShipment]="item.data?.Shipment"
                                 [price]="item.data?.Shipment.RatedPrice.Value"
                                 (appliedDiscount)="onDiscountApplied($event, item.index,'inbound')"></discount-calculator>
          </td>
          <td>{{fixDecimals(item.data?.Shipment.RatedPrice.Value + ' ' + code)}}</td>
          <td>{{findVerticalTotal('inbound', item.index) + ' ' + code}}</td>
          <!-- <td>{{fixDecimals(item.data?.Amount)+ ' ' + code}}</td> -->
        </tr>
        <tr class="no-border">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td><h3>{{ 'common.total' | translate }}</h3></td>
          <td><h3>{{ fixDecimals(getTotalBasedOnCode(code, 'inbound')) + ' ' + code }}</h3></td>
        </tr>
      </tbody>
    </table>
  </div>
  <h5 *ngIf="shippments?.misc?.length >0"><b>{{ 'common.misc' | translate }}</b></h5>
  <table *ngIf="shippments?.misc?.length >0" class="table table-bordered table-striped receipt-table">
    <thead>
      <tr>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.hawb' | translate }}</b></th>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.consignee' | translate }}</b></th>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.org' | translate }}</b></th>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.dst' | translate }}</b></th>
        <th><b>{{ 'common.type' | translate }}</b></th>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.qty' | translate }}</b></th>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cwgt' | translate }}</b></th>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cstms' | translate }}</b></th>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cod' | translate }}</b></th>
        <th><b>{{ 'common.discount' | translate }}</b></th>
        <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.rtdPrice' | translate }}</b></th>
        <th><b>{{ 'common.total' | translate }}</b></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of shippments.misc; index as i">
        <td>
          <span class="armx-icon armx-trash delete-btn" (click)="removeShipment('misc',i)"></span> {{item?.Shipment?.Number}}
        </td>
        <td>
          {{item?.Shipment?.ConsigneeName}}
        </td>
        <td>{{item?.Shipment?.OriginAddress?.Entity}}</td>
        <td>{{item?.Shipment?.DestinationAddress?.Entity}}</td>
        <td>{{item?.Shipment?.ProductType}}</td>
        <td>{{item?.Shipment?.Quantity}}</td>
        <td>{{fixDecimals(item.Shipment?.ChargeableWeight?.Value)}}</td>
        <td>{{item?.Shipment?.Customs?.Value}}
          <span *ngIf="item.data?.Shipment?.Customs?.Value">{{' '+ item.data?.Shipment?.Customs?.Code }}</span>
        </td>
        <td>{{item?.Shipment?.CashOnDelivery?.Value}}
          <span *ngIf="item.data?.Shipment?.CashOnDelivery?.Value">{{' '+ item.data?.Shipment?.CashOnDelivery?.Code }}</span>
        </td>
        <td class="discount">-</td>
        <td>{{ fixDecimals(item?.Shipment?.RatedPrice?.Value)}}</td>
      </tr>
      <tr class="no-border">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td><h3>{{ 'common.total' | translate }}</h3></td>
        <td><b>{{findTotal('misc','Customs','Value')}}</b></td>
        <td><b>{{findTotal('misc','Customs','Value')}}</b></td>
        <td><b>{{findTotal('misc','CashOnDelivery','Value')}}</b></td>
        <td><b>-</b></td>
        <td><h3>{{ fixDecimals(findTotal('misc','Amount',''))}}</h3></td>
      </tr>
    </tbody>
  </table>
  
  <h5 *ngIf="shippments?.dropoff?.length >0"><b>{{ 'common.dropOff' | translate }}</b></h5>
  <div *ngFor="let code of getAllCurrency()">
    <table *ngIf="localShipmentsByCurrencyDO[code] && localShipmentsByCurrencyDO[code].length > 0" class="table table-bordered table-striped receipt-table">
      <thead>
        <tr>
          <th colspan="2"><b>{{ 'pages.createReceiptPage.oneReceipt.table.hawb' | translate }}</b></th>
          <th colspan="2"><b>{{ 'pages.createReceiptPage.oneReceipt.table.consignee' | translate }}</b></th>
          <th colspan="1"><b>{{ 'pages.createReceiptPage.oneReceipt.table.org' | translate }}</b></th>
          <th colspan="1"><b>{{ 'pages.createReceiptPage.oneReceipt.table.dst' | translate }}</b></th>
          <th colspan="1"><b>{{ 'common.type' | translate }}</b></th>
          <th colspan="1"><b>{{ 'pages.createReceiptPage.oneReceipt.table.qty' | translate }}</b></th>
          <th colspan="1"><b>{{ 'pages.createReceiptPage.oneReceipt.table.wgt' | translate }}</b></th>
          <th colspan="1"><b>{{ 'common.discount' | translate }}</b></th>
          <th colspan="2"><b>{{ 'common.total' | translate }}</b></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of localShipmentsByCurrencyDO[code];">
          <td colspan="2">
            <span class="armx-icon armx-trash delete-btn" (click)="removeShipment('dropoff', item.index, code)"></span> {{item.data.Shipment.Number}}
          </td>
          <td colspan="2">
            {{item.data.Shipment.ConsigneeName}}
          </td>
          <td colspan="1">{{item.data.Shipment.OriginAddress.Entity}}</td>
          <td colspan="1">{{item.data.Shipment.DestinationAddress.Entity}}</td>
          <td colspan="1">{{item.data.Shipment.ProductType}}</td>
          <td colspan="1">{{item.data.Shipment.Quantity}}</td>
          <td colspan="1">{{fixDecimals(item.data.Shipment.GrossWeight.Value)}}</td>
          <td colspan="1" class="discount">
            <discount-calculator *ngIf="item.data?.Amount != 0 && allowDiscountOutbound"
                                 [discountAmount]="item.data?.DiscountAmount"
                                 receiptType="dropoff"
                                 [accountCurrencyCode]="code"
                                 [discountComments]="item.data?.DiscountComments"
                                 [cmpDiscountValue]="item.data?.DiscountValue"
                                 [cmpDiscountValueBy]="item.data?.DiscountValueBy"
                                 [currentShipment]="item.data?.Shipment"
                                 [price]="item.data?.Shipment.NewCost.Value"
                                 (appliedDiscount)="onDiscountApplied($event, item.index, 'dropoff')"></discount-calculator>
          </td>
          <td colspan="2">{{fixDecimals(item.data?.Amount) + ' ' + code}}</td>
        </tr>
        <tr class="no-border">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td><h3>{{ 'common.total' | translate }}</h3></td>
          <td><h3>{{ fixDecimals(getTotalBasedOnCode(code, 'dropoff')) + ' ' + code }}</h3></td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- packaging shipment -->
  <h5 *ngIf="shippments?.Packaging?.length > 0">
    <b>{{ 'common.packaging' | translate }}</b>
  </h5>
  
  <div *ngFor="let code of getAllCurrency()">
    <table *ngIf="localShipmentsByCurrencyPackaging[code] && localShipmentsByCurrencyPackaging[code].length > 0" class="table table-bordered table-striped receipt-table">
      <thead>
        <tr>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.hawb' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.consignee' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.uppperCaseORG' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.upperCaseDST' | translate }}</b></th>
          <th><b>{{ 'common.type' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.upperCaseQTY' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cwgt' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cstms' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.cod' | translate }}</b></th>
          <th><b>{{ 'common.discount' | translate }}</b></th>
          <th><b>{{ 'pages.createReceiptPage.oneReceipt.table.rtdPrice' | translate }}</b></th>
          <th><b>{{ 'common.total' | translate }}</b></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of localShipmentsByCurrencyPackaging[code]; let i = index">
          <td>
            <span class="armx-icon armx-trash delete-btn" (click)="removeShipment('Packaging', i, code)"></span>
            <div title="{{ 'common.duplicate' | translate }}" class="duplicate-btn" (click)="onDuplicateShipment(item.data, code)">
              <img src="/assets/icons/duplicate.svg" alt="Duplicate" />
            </div>
            {{ item.data.Shipment.Number }}
          </td>
          <td>{{ item.data.Shipment.ConsigneeName }}</td>
          <td>{{ item.data.Shipment.OriginAddress.Entity }}</td>
          <td>{{ item.data.Shipment.DestinationAddress.Entity }}</td>
          <td>{{ item.data?.Shipment?.ProductType }}</td>
          <td>{{ item.data?.Shipment?.CashOnDelivery?.Value }}
            <span *ngIf="item.data?.Shipment?.CashOnDelivery?.Value">{{ ' ' + item.data?.Shipment?.CashOnDelivery?.Code }}</span>
          </td>
          <td>{{ item.data?.Shipment?.Weight }}</td> 
          <td>{{ item.data?.Shipment?.CustomsValue }}</td> 
          <td>{{ item.data?.Shipment?.CashOnDelivery?.Value }}</td>
          <td>{{ item.data?.Discount }}</td> 
          <td>{{ fixDecimals(item.data?.Shipment.RatedPrice.Value) + ' ' + code }}</td>
          <td>{{ fixDecimals(item.data?.Amount) + ' ' + code }}</td>
        </tr>
        <tr class="no-border">
          <td colspan="10"><h3>{{ 'common.total' | translate }}</h3></td>
          <td><h3>{{ fixDecimals(getTotalBasedOnCode(code, 'Packaging')) + ' ' + code }}</h3></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="empty-shippment" *ngIf="!isThereShippments()"><i class="armx-icon armx-folder-open-empty"></i><br /><span>{{ 'pages.createReceiptPage.oneReceipt.table.noShipments' | translate }}</span></div>
  <div class="pull-right">
    <button class="btn btn-info"
            (click)="addShippment()">
      {{ 'pages.createReceiptPage.oneReceipt.table.addNewshipment' | translate }}
    </button>
    <button class="btn btn-primary" style="margin-left:20px;" *ngIf="isThereShippments()" (click)="next()">{{ 'pages.createReceiptPage.oneReceipt.table.checkOut' | translate }}</button>
  </div>
</div>

